/**
 * Wiederholungsregeln fuer Aufgaben (F-24) - dieselbe Regelsprache und
 * derselbe "floating"-Trick wie bei Terminen (siehe expand.ts), nur auf
 * ganzen Tagen. Aufgaben haben keine Uhrzeit in der Regel.
 */
import { RRule, rrulestr } from 'rrule';

import { fromFloatingUtc, toFloatingUtc } from '@/lib/recurrence/expand';
import type { LocalDate } from '@/domain/types';

export interface TagesRegel { rrule: string; start: LocalDate }

/** Schutz gegen absurde Regeln - mehr Vorkommen zaehlt niemand. */
const MAX = 400;

function regel(r: TagesRegel): RRule | null {
  try {
    const parsed = rrulestr(`RRULE:${r.rrule.replace(/^RRULE:/i, '')}`, { dtstart: toFloatingUtc(r.start) });
    return parsed instanceof RRule ? parsed : null;
  } catch {
    return null;
  }
}

const tag = (d: Date) => fromFloatingUtc(d).slice(0, 10) as LocalDate;

/** Erstes Vorkommen ab `ab` (bzw. danach, wenn nicht `inklusive`); `null` am Ende der Serie. */
export function naechstesVorkommen(r: TagesRegel, ab: LocalDate, inklusive: boolean): LocalDate | null {
  const d = regel(r)?.after(toFloatingUtc(ab), inklusive);
  return d ? tag(d) : null;
}

/** Alle Vorkommen von `von` bis `bis`, beide einschliesslich. */
export function vorkommenZwischen(r: TagesRegel, von: LocalDate, bis: LocalDate): LocalDate[] {
  if (bis < von) return [];
  const rule = regel(r);
  if (!rule) return [];
  return rule.between(toFloatingUtc(von), toFloatingUtc(bis), true, (_, i) => i < MAX).map(tag);
}
